// extracted by css-extract-rspack-plugin
export default {"container":"vE4GJ","icon":"I9FaJ","button_override":"PPedi","buttonOverride":"PPedi","#":"j_ZBT","label":"hjSUg"};